import { ONBOARDING_TUTORIAL_STORAGE_KEY_PREFIX } from "@/constants";
import { parseJsonSafe } from "@/utils/utils";

export interface OnboardingState {
    optedOut: boolean;
    completed: boolean;
}

const buildKey = (userId: number) =>
    `${ONBOARDING_TUTORIAL_STORAGE_KEY_PREFIX}_${userId}`;

const safeGetItem = (key: string): string | null => {
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
};

const safeSetItem = (key: string, value: string): void => {
    try {
        localStorage.setItem(key, value);
        // eslint-disable-next-line no-empty
    } catch {}
};

export const getOnboardingState = (userId: number): OnboardingState | null => {
    const raw = safeGetItem(buildKey(userId));
    if (!raw) return null;
    const parsed = parseJsonSafe(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed as OnboardingState;
};

const writeOnboardingState = (userId: number, state: OnboardingState): void => {
    safeSetItem(buildKey(userId), JSON.stringify(state));
};

const updateOnboardingState = (
    userId: number,
    patch: Partial<OnboardingState>,
): void => {
    const state = getOnboardingState(userId) ?? {
        optedOut: false,
        completed: false,
    };
    writeOnboardingState(userId, { ...state, ...patch });
};

export const setOnboardingCompleted = (userId: number): void =>
    updateOnboardingState(userId, { completed: true });

export const setOnboardingOptedOut = (userId: number): void =>
    updateOnboardingState(userId, { optedOut: true });
